import { type SelectDataObject } from '../_tools/inputfields/Select';

const sFarbschema: Record<
    number,
    SelectDataObject<{ color: string; type: 'baseColor' } | { dashboard: string; leads: string; fahrzeuge: string; kunden: string; qr: string; bdc: string; other: string; type: 'preDefined' }>
> = {
    0: { t: 'AHD Cars', hidden: false, dashboard: '#4caf50', leads: '#2196f3', fahrzeuge: '#2e7d32', kunden: '#e53935', qr: '#ff9800', bdc: '#9c27b0', other: '#607d8b', type: 'preDefined' },
    1: { t: 'Alfa Romeo', color: '#8f0c25', hidden: false, type: 'baseColor' },
    2: { t: 'Aston Martin', color: '#246b59', hidden: false, type: 'baseColor' },
    3: { t: 'Audi', color: '#bb0a31', hidden: false, type: 'baseColor' },
    4: { t: 'Bentley', color: '#9c9376', hidden: false, type: 'baseColor' },
    5: { t: 'BMW', color: '#0f81ca', hidden: false, type: 'baseColor' },
    6: { t: 'Citrön', color: '#d30024', hidden: false, type: 'baseColor' },
    7: { t: 'Dacia', color: '#0e4d9d', hidden: false, type: 'baseColor' },
    8: { t: 'Daihatsu', color: '#da251c', hidden: false, type: 'baseColor' },
    9: { t: 'Ferrari', color: '#c4151c', hidden: false, type: 'baseColor' },
    10: { t: 'Fiat', color: '#b71c48', hidden: false, type: 'baseColor' },
    11: { t: 'Ford', color: '#003179', hidden: false, type: 'baseColor' },
    12: { t: 'Honda', color: '#ec1c2f', hidden: false, type: 'baseColor' },
    13: { t: 'Hyundai', color: '#213d7d', hidden: false, type: 'baseColor' },
    14: { t: 'Jaguar', color: '#263a2f', hidden: false, type: 'baseColor' },
    15: { t: 'Kia', color: '#c6192d', hidden: false, type: 'baseColor' },
    16: { t: 'Lamborghini', color: '#d9a10e', hidden: false, type: 'baseColor' },
    17: { t: 'Lancia', color: '#00306b', hidden: false, type: 'baseColor' },
    18: { t: 'Land Rover', color: '#06703b', hidden: false, type: 'baseColor' },
    19: { t: 'Lexus', color: '#bcab95', hidden: false, type: 'baseColor' },
    20: { t: 'Mazda', color: '#0081c6', hidden: false, type: 'baseColor' },
    21: { t: 'Mercedes-Benz', color: '#bcbdbc', hidden: false, type: 'baseColor' },
    22: { t: 'Mitsubishi', color: '#d20621', hidden: false, type: 'baseColor' },
    23: { t: 'Nissan', color: '#868686', hidden: false, type: 'baseColor' },
    24: { t: 'Opel', color: '#ffed00', hidden: false, type: 'baseColor' },
    25: { t: 'Peugeot', color: '#00509c', hidden: false, type: 'baseColor' },
    26: { t: 'Porsche', color: '#d8b664', hidden: false, type: 'baseColor' },
    27: { t: 'Renault', color: '#fdb60d', hidden: false, type: 'baseColor' },
    28: { t: 'Rolls-Royce', color: '#10069f', hidden: false, type: 'baseColor' },
    29: { t: 'Seat', color: '#e30013', hidden: false, type: 'baseColor' },
    30: { t: 'Skoda', color: '#4aa82e', hidden: false, type: 'baseColor' },
    31: { t: 'Smart', color: '#f58634', hidden: false, type: 'baseColor' },
    32: { t: 'Subaru', color: '#21529f', hidden: false, type: 'baseColor' },
    33: { t: 'Suzuki', color: '#bf2e24', hidden: false, type: 'baseColor' },
    34: { t: 'Toyota', color: '#f34a4f', hidden: false, type: 'baseColor' },
    35: { t: 'Volvo', color: '#1f3467', hidden: false, type: 'baseColor' },
    36: { t: 'Volkswagen', color: '#151f5d', hidden: false, type: 'baseColor' },
};
export default sFarbschema;
